"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextInput_1 = __importDefault(require("components/core/inputs/TextInput"));
var Button_1 = __importDefault(require("components/core/buttons/Button"));
var bridgestone_full_svg_1 = __importDefault(require("res/img/bridgestone-full.svg"));
var Loading_1 = __importDefault(require("../Loading"));
var LoginForm = function (_a) {
    var userData = _a.userData, onChange = _a.onChange, onSubmit = _a.onSubmit, busy = _a.busy;
    return (react_1.default.createElement("div", { className: "login-form" },
        react_1.default.createElement("div", { className: "login-form__logo" },
            react_1.default.createElement("img", { src: bridgestone_full_svg_1.default, alt: "Bridgestone" })),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement(TextInput_1.default, { type: "text", name: "username", value: userData.username, onChange: onChange, autoFocus: true }),
            react_1.default.createElement(TextInput_1.default, { type: "password", name: "password", value: userData.password, onChange: onChange }),
            react_1.default.createElement(Button_1.default, { type: "submit", title: "Log In", icon: busy ? react_1.default.createElement(Loading_1.default, null) : null }, "Log In"))));
};
exports.default = LoginForm;
